<template>
    <div class="modal fade" ref=":post" id="promptModal" tabindex="-1" role="dialog" aria-labelledby="promptModal" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <form @submit.prevent="onSumbit" class="form-group">
                    <div class="modal-body">
                            <label for="promptModalInput" v-html="message"></label>
                            <input class="form-control" id="promptModalInput" type="number" min="0" max="600" v-model="value" autofocus>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">{{ $t('js.actions.cancel') }}</button>
                        <button type="submit" class="btn btn-danger">{{ $t('js.actions.submit') }}</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "PromptModal",
        props: {
            message: {
                type: String,
                required: true
            },
            default: {
                type: Number,
                default: 0
            }
        },
        data() {
            return {
                value: {
                    type: Number,
                    default: this.default
                }
            }
        },
        methods:{
            onSumbit() {
                this.$emit('submit', this.value);
                this.value = null;
                $('#promptModal').modal('hide');
            }
        }
    }
</script>